import React from 'react';
import PageHeader from 'components/PageHeader/PageHeader';
import { Button, Icon, IconList } from 'components/core';

type Props = {
  backLink: string;
  fullTextBulkUploadPath?: string;
};

const FullTextReviewPageHeader = ({
  backLink,
  fullTextBulkUploadPath,
}: Props) => {
  return (
    <PageHeader
      headerText="Full text review"
      backLink={backLink}
      rightContent={() => {
        if (!fullTextBulkUploadPath) return null;

        return (
          <Button to={fullTextBulkUploadPath} type="brand">
            <Icon size="lg" icon={IconList.solid.faCloudUploadAlt} />
            Bulk upload missing full texts
          </Button>
        );
      }}
    />
  );
};

export default FullTextReviewPageHeader;
